import HomePage from './pages/Page.vue';

export { HomePage };